'use strict'

module.exports = require('./dist/react-aria-tooltip')



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-aria-tooltip/index.js
// module id = 86
// module chunks = 0